module.exports = __webpack_public_path__ + "img/logo.1ec224b1.png";